<template>
  <div class="first-row-full-height tender-list-cell">
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'TenderListFullHeightHeaderCell',
  };
</script>
